import { cilBarcode, cilInfo, cilKeyboard } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { CBadge, CButton, CImg } from '@coreui/react';
import * as React from 'react';
import { Redirect } from 'react-router';
import { IConfirmBoxParams, IErrorMessages } from '../abstraction/';
import { KAlertPopup, KBarCodeStatus, KConfirmPopup, KLoadingPanel, KTechPopup, NavMenu } from '../components';
import { AppLabels } from '../core/AppLabels';
import disableImg from '../img/disable.png';
import { barCodeSvc, dispatcher, securitySvc } from '../Karma';
import { LoginView } from './LoginView';

interface IProps {
	children?: React.ReactNode;
}

interface IState {
	errorPanelOptions: IErrorMessages;
	isErrorPanelOpen: boolean;
	confirmWindowOptions: IConfirmBoxParams;
	isConfirmWindowOpen: boolean;
	isWaitPanelOpen: boolean;
	isTechInfosOpen: boolean;
	barCodeValue: string;
	redirectUrl: string;
	keyboard: boolean;
	showWaitPanel: boolean;
}

// Container principal
// Toutes les pages sont affichées dans ce composant
//
export class Layout extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);

		this.state = {
			isErrorPanelOpen: false,
			isConfirmWindowOpen: false,
			errorPanelOptions: { messages: [], type: 1, title: AppLabels.errorTitle },
			isWaitPanelOpen: false,
			barCodeValue: "",
			confirmWindowOptions: null,
			redirectUrl: "",
			isTechInfosOpen: false,
			keyboard: dispatcher.isVirtualKeyboardActive,
			showWaitPanel: true,
		}

		//#region Events subcribtions

		// Si le dispatcher nous demande d'afficher un message, on le fait
		dispatcher.OnShowMessageBox.add((data: IErrorMessages) => {
			this.setState({ errorPanelOptions: data })
			this.setState({ isErrorPanelOpen: true })
		})

		// Si le dispatcher nous demande d'afficher un message avec confirmation, on le fait aussi (on a assez obéissant en fait)
		dispatcher.OnConfirm.add((options: IConfirmBoxParams) => {
			this.setState({ confirmWindowOptions: options })
			this.setState({ isConfirmWindowOpen: true })
		})

		// Retour de la fenêtre de confirmation. On cache la fenetre
		dispatcher.OnCloseConfirm.add(() => {
			this.setState({ isConfirmWindowOpen: false })
		})

		// Démarrage d'une requête Ajax vers le serveur
		// Count indique le nombre de requête en cours
		dispatcher.OnRequestStart.add((count) => {
			if (window.document.location.toString().toLowerCase().indexOf("/stress") == -1)
				this.setState({ isWaitPanelOpen: true })
		});

		// Fin de requête ajax
		// Count indique le nombre de requête en cours
		dispatcher.OnRequestEnd.add((count) => {
			this.setState({ isWaitPanelOpen: false })
		});

		dispatcher.OnTokenEOLReached.add(async () => {
			let result = await dispatcher.ConfirmBox("", AppLabels.sessionWillTimeout, AppLabels.yes, AppLabels.no, 30);
			if (result == true) {
				try {
					await securitySvc.RefreshAuthToken();
					return;
				}
				catch (err: any) {
					console.error(err);
				}
			}
			let resultout = await securitySvc.Logout();
			console.log("OnTokenEOLReached : ");
			console.log(resultout);
		});

		dispatcher.OnSessionEnding.add(async () => {
			let result = await dispatcher.ConfirmBox("", AppLabels.sessionInactivityTimeout, AppLabels.keepLogged, AppLabels.Logout, 20);
			if (result == true) {
				securitySvc.setSessionTimeOutWarning();
				return;
			}

			let resultout = await securitySvc.Logout();
			console.log("OnTokenEOLReached : ");
			console.log(resultout);
		});

		//#endregion Events

	}

	//#region React Hacks

	// Pour éviter un warning sur la console JS du navigateur, on se désabonne des évènements
	componentWillUnmount = () => {
		dispatcher.OnShowMessageBox.reset();
		dispatcher.OnConfirm.reset();
		dispatcher.OnRequestStart.reset();
		dispatcher.OnRequestEnd.reset();
		dispatcher.OnCloseConfirm.reset();
		dispatcher.OnTokenEOLReached.reset();
		dispatcher.OnSessionEnding.reset();
		dispatcher.OnGenericAction.reset();
	}

	//#endregion

	//#region Events

	// Clic sur le panel d'erreur = fermeture du panel
	onErrorPanelCloseClick = () => {
		this.setState({ isErrorPanelOpen: false, })
	}

	// Clic sur le bouton de simulation d'un code barre
	// On transmet on gestionnaire correspondant
	onSendBarCodeClick = (event) => {
		if (this.state.barCodeValue) {
			barCodeSvc.SimulateBarCode(this.state.barCodeValue);
			this.setState({ barCodeValue: "" });
		}
	}

	// Mise à jour de la zone de saisie d'un code barre
	onBarcodeChanged = (event) => {
		let value: string = event.target.value;
		this.setState({ barCodeValue: value });
	}

	onKeyboardClick = (event) => {
		this.setState({ keyboard: !this.state.keyboard });
		dispatcher.isVirtualKeyboardActive = !this.state.keyboard;
	}

	//#endregion Events

	//#region Rendus


	renderCBSim = () => {
		if (securitySvc.currentUser.CBManuel == false) return "";
		return <div>
			<div className="TechInfo" onClick={() => { this.setState({ isTechInfosOpen: !this.state.isTechInfosOpen }) }}>
				<span><CIcon content={cilInfo} size="xl" /></span>
			</div>
			<div className="barcode">
				<input onChange={this.onBarcodeChanged} value={this.state.barCodeValue}></input>
				<CButton onClick={this.onSendBarCodeClick} shape="square" size="sm" color="secondary"><CIcon content={cilBarcode} /></CButton>

			</div>
		</div>
	}

	renderExtraTools = () => {
		return (
			<div>
				<KTechPopup logsProvider={dispatcher} infos={dispatcher} isOpen={this.state.isTechInfosOpen} onClose={() => { this.setState({ isTechInfosOpen: false }) }} />
				{this.renderCBSim()}
			</div>
		);
	}

	renderStatusBar = () => {
		if (!securitySvc.isAuth()) return "";

		let extraTools = securitySvc.currentUser.CBManuel == true ? this.renderExtraTools() : "";
		let img = !this.state.keyboard ? <CImg src={disableImg} /> : "";

		return (
			<div className={" KStatusBar "} >
				<KBarCodeStatus barcodeService={barCodeSvc} />

				<div style={{ color: this.state.keyboard ? 'white' : 'black' }} className="Keyboard" onClick={this.onKeyboardClick}>
					{img}
					<CIcon content={cilKeyboard} name="cilKeyboard" size="sm" />
				</div>

				{extraTools}
			</div>
		);
	}

	render() {

		// Si l'utilisateur est authentifié, on récupère les durées avant fermeture auto
		let timeOut = 20;
		let fullname = "";
		if (securitySvc.currentUser) {
			fullname = securitySvc.currentUser.fullname;
			switch (this.state.errorPanelOptions.type) {
				case 1:
					timeOut = securitySvc.currentUser.OKTimeOut
					break;
				case 2:
					timeOut = securitySvc.currentUser.WarnTimeOut
					break;
				case 3:
					timeOut = securitySvc.currentUser.ErrorTimeOut
					break;
			}
		}


		let opt = this.state.confirmWindowOptions;
		if (this.state.redirectUrl) return <Redirect to={this.state.redirectUrl} ></Redirect>
		let errorPanel = (this.state.isErrorPanelOpen) ? <KAlertPopup timeOut={timeOut} isOpen={this.state.isErrorPanelOpen} onClose={this.onErrorPanelCloseClick} infos={this.state.errorPanelOptions}></KAlertPopup> : "";
		let confirmPanel = (this.state.isConfirmWindowOpen) ? <KConfirmPopup isOpen={this.state.isConfirmWindowOpen} title={opt.title} message={opt.message} noText={opt.noText} yesText={opt.yesText} closeCallBack={opt.closeCallBack} duration={opt.duration}></KConfirmPopup> : "";

		let content = !securitySvc.isAuth() ? <LoginView /> : this.props.children;

		let statusbar = this.renderStatusBar();

		let wait = this.state.isWaitPanelOpen ? <KLoadingPanel></KLoadingPanel> : "";

		return (
			// En cas de clic ou d'entrée clavier, on remet le compteur d'inactivité à 0
			<div onClick={() => { securitySvc.setSessionTimeOutWarning() }} onKeyUp={() => { securitySvc.setSessionTimeOutWarning() }} >
				<NavMenu disableRedirection={dispatcher.getLastViewContext()} securityService={securitySvc} userFullName={fullname} />
				{errorPanel}
				{confirmPanel}
				{wait}
				{content}
				<br /><br /><br /><br />
				{statusbar}
			</div>
		);
	}

	//#endregion
}
